<script>
  import { money } from '../util.js';
  import { SvelteToast, toast } from '@zerodevx/svelte-toast';
  export let item, // item instance (e.g. catalog search hit, cart item, etc.)
    action;
  const options = {
      duration: 10000,
      theme: { '--toastBackground': 'white', '--toastColor': 'black' },
    },
    viewItem = () => {
      console.log(item.name, item.description);
      toast.push(
        `
        <strong>${item.name}</strong><br/>${item.description}<br/><br/>
        <img src="https://www.servicechamp.com/images/products/small/${item.name}_1_small.jpg"
          alt="${item.description}"
          onerror="this.onerror=null;this.src='no-image-icon.png';" /><br/><br/>
  `,
        options
      );
    };
</script>

<tr>
  <td>
    <span class="clickableItem" on:click={viewItem}>{item.name}</span>
    @
    <span>{money.format(item.price)}</span>
    <br />
    {item.description}
  </td>
  <td>
    <input
      id={item.name}
      type="number"
      class:error={item.qty % item.quantity > 0 ||
        item.qty > item.maxQuantity ||
        item.qty < 0 ||
        (isNaN(parseInt(item.qty)) && !item.qty == '') ||
        item.qty == null}
      min="0"
      max={item.maxQuantity}
      step={item.quantity}
      bind:value={item.qty}
      on:input={(e) => action(e.target.id, e.target.value)}
    />
  </td>
  <td>
    <div>
      {item.quantity} per pak,<br />{item.maxQuantity} per order max
    </div>
  </td>
</tr>

<SvelteToast />

<style>
  input {
    width: 65px;
    text-align: right;
  }
  .error {
    background-color: yellow;
  }
  .clickableItem {
    font-weight: 500;
    cursor: pointer;
  }
</style>
